export default {
  getValidMeta: state => {
    const meta = {};
    Object.entries(state.changed).map(([key, value]) => {
      if (value.valid) {
        meta[key] = value;
      }
    });
    return meta;
  },
  getOldValue: state => key => {
    const value = Object.values(state.changed).filter(x => x.variable === key || x.validRef === key);
    if (Array.isArray(value) && value.length > 0) {
      return value[0];
    }
    return null;
  }
};
